import axios from 'axios';

export async function getRetirementFactors() {
  const response = await axios.get('/retirement-factors');
  return response.data;
}

export async function createRetirementFactors(body = {}) {
  const response = await axios.post('/retirement-factors', body);
  return response.data;
} 